import { useTranslation } from "react-i18next";
import { PMSimpleSelectorField } from "../PMSimpleSelector/PMSimpleSelectorField";
import { PMSimpleSelectorFieldV2 } from "../PMSimpleSelector/PMSimpleSelectorFieldV2";
import axios from "../../../api/axios";
import { useState, useEffect } from "react";
import { mapErrors } from "../../Utils";
import { Form, Formik } from "formik";
import { ResourceLoading } from "../ResourceLoading";
import * as Yup from "yup";
import { toast } from "react-hot-toast";
import { PMField } from "../PMField";
import { debounce } from "lodash";

export const CaseSelector = ({ showField = true, ...props }) => {
  const {
    setFieldValue,
    values,
    onChange,
    errors,
    module,
    module_param,
    fields,
    searchQuery,
  } = props;

  const name = props?.name ? props.name : "case_id";
  const label = props?.label ? props.label : "Case";
  const FETCH_URL = `/cases/`;
  const filters = null;

  const { t } = useTranslation();

  const [query, setQuery] = useState();
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState({
    id: 0,
    field1: "Ingen valgt",
    field2: null,
  });
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (props.open === true) {
      setOpen(true);
    } else if (props.open === false) {
      setOpen(false);
    }
  }, [props.open]);

  const handleChange = (data) => {
    if (data.selected.item.id !== null) {
      getItem(data.selected.item.id);
    } else {
      setSelected({
        id: data?.selected?.item?.id,
        field1: data?.selected?.item?.primary,
      });
    }

    setOpen(false);
    props.onClose?.(false);

    if (values) {
      setFieldValue(name, data.selected.item.id);
    }

    if (onChange) {
      onChange({
        target: {
          name: name,
          value: data.selected.item.id,
          data: data?.selected?.item,
        },
      });
    }
  };

  useEffect(() => {
    if (props?.selected?.id) {
      setSelected({
        id: props.selected?.id,
        field1: props.selected?.displayTitle,
      });
    }
  }, [props.selected]);

  const handleSelectFromForm = (data) => {
    setSelected({
      id: data?.id,
      field1: data?.displayTitle,
    });
    if (values) {
      setFieldValue(name, data?.id);
    } else {
      onChange({ target: { name: name, value: data?.id } });
    }
  };

  const getItem = (id) => {
    return axios({ method: "get", url: FETCH_URL + id })
      .then((res) => {
        if (res.data.id) {
          setLoading(false);
          setSelected({
            id: res.data?.id,
            field1: res.data?.displayTitle,
          });
        }
      })
      .catch((err) => {
        let errors = null;
        if (err?.data?.errors) {
          errors = mapErrors(err.data.errors);
        } else {
          errors = ["Something went wrong"];
        }
        setLoading(false);
      });
  };

  const [controller, setController] = useState({
    query: query ? query : "",
    page: 1,
    sortBy: "updated_at",
    sort: "desc",
    filters: filters,
    view: null,
    fields: fields,
  });

  useEffect(() => {
    setController((prev) => ({ ...prev, query: query }));
  }, [query]);

  const getItems = (controller) => {
    setLoading(true);
    return axios({ method: "get", url: FETCH_URL, params: controller })
      .then((response) => {
        if (response.data.data) {
          var array = [
            { id: null, value: null, primary: "Ingen valgt", secondary: null },
          ];
          if (!response.data.data) return array;
          response.data.data.map((row, i) => {
            const rowParams = {
              value: row.id,
              id: row.id,
              primary: row?.displayTitle || `Case #${row.case_number}`,
              secondary: row?.customer?.displayTitle || "No customer",
              object: row,
            };
            array.push(rowParams);
          });
          setItems(array);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        return error.response.data;
      });
  };

  const debouncedDispatchAction = debounce((controller) => {
    getItems(controller);
  }, 500);

  useEffect(() => {
    // Trigger the debounced dispatch action
    if (open) {
      debouncedDispatchAction(controller);
    }

    // Clean the debounced function on component unmount.
    return () => {
      debouncedDispatchAction.cancel();
    };
  }, [controller, open]);

  return (
    <>
      <PMSimpleSelectorFieldV2
        showField={showField}
        errors={errors}
        name={name}
        loading={loading}
        label={t(label)}
        options={items}
        selected={selected}
        onChange={handleChange}
        onQueryChange={(query) => setQuery(query)}
        onClose={() => setOpen(!open)}
        open={open}
        searchQuery={searchQuery}
        disabled={props.disabled}
      />
    </>
  );
};
